module.exports = __webpack_public_path__ + "static/media/blog-43-2.c16a8bc0.webp";